import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function initMatterDocumentTopics(requestor) {
  return createReduxPromiseAction(
    ActionTypes.TOPICS_FETCH,
    (organisationId, projectId, matterId, documentId) =>
      requestor
        .get(
          `${basePath}/organisation/${organisationId}/project/${projectId}/` +
            `matter/${matterId}/document/${documentId}/topic`,
          {withCredentials: true},
        )
        .then(response => response.data),
  );
}
